<rt-form-field [style.width]="width()">
  <rt-input
    [formControl]="nameControl()"
    [placeholder]="placeholder()"
    [rtFormError]="formErrors()"
    [autoFocus]="autoFocus()"
    [disabled]="disabled()"
    [maxLength]="maxLength()"
    (blur)="onNameBlur()"
  >
    <span #symbolOrigin prefix (click)="onSymbolClick(symbolOrigin)" class="symbol-picker">
      <rt-symbol
        [symbol]="symbolControl().value"
        [fallbackSymbol]="fallbackSymbol()"
        [fallbackIcon]="fallbackIcon()"
        [forceFallback]="forceFallback()"
      />
    </span>
  </rt-input>
</rt-form-field>
